var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.33334C4.31826 1.33334 1.3335 4.31811 1.3335 8.00001C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00001C14.6668 6.2319 13.9645 4.53621 12.7142 3.28596C11.464 2.03572 9.76827 1.33334 8.00016 1.33334ZM8.66683 10.6667C8.66683 11.0349 8.36835 11.3333 8.00016 11.3333C7.63197 11.3333 7.3335 11.0349 7.3335 10.6667V7.33334C7.3335 6.96515 7.63197 6.66668 8.00016 6.66668C8.36835 6.66668 8.66683 6.96515 8.66683 7.33334V10.6667ZM7.3335 5.33334C7.3335 5.70153 7.63197 6.00001 8.00016 6.00001C8.36835 6.00001 8.66683 5.70153 8.66683 5.33334C8.66683 4.96515 8.36835 4.66668 8.00016 4.66668C7.63197 4.66668 7.3335 4.96515 7.3335 5.33334Z",
    fill: "#6D6D70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.527162d22dc28c96f4d9a91df945a8c0.svg";
export { ForwardRef as ReactComponent };